import Select from "components/shared/select";
import moment from "moment";
import React, { useEffect } from "react";

export default function MonthYearFilter({ values, setFilter }) {
    const minYear = 2021;
    const minMonth = "09";
    const currentYear = moment().year();
    const currentMonth = moment().format("MM");
    const monthsOptions = [
        { label: "Январь", value: "01" },
        { label: "Февраль", value: "02" },
        { label: "Март", value: "03" },
        { label: "Апрель", value: "04" },
        { label: "Май", value: "05" },
        { label: "Июнь", value: "06" },
        { label: "Июль", value: "07" },
        { label: "Август", value: "08" },
        { label: "Сентябрь", value: "09" },
        { label: "Октябрь", value: "10" },
        { label: "Ноябрь", value: "11" },
        { label: "Декабрь", value: "12" },
    ];

    const getValidYear = (year) => {
        const numericYear = Number(year);
        return numericYear >= minYear && numericYear <= currentYear ? numericYear : currentYear;
    };

    const getValidMonth = (month, year) => {
        const monthValue = month === null || month === undefined ? "" : month.toString().padStart(2, "0");
        const validMonth = monthsOptions.some(({ value }) => value === monthValue) ? monthValue : currentMonth;

        if (year === minYear && parseInt(validMonth, 10) < parseInt(minMonth, 10)) {
            return minMonth;
        }
        if (year === currentYear && parseInt(validMonth, 10) > parseInt(currentMonth, 10)) {
            return currentMonth;
        }
        return validMonth;
    };

    const getReportPeriod = (year, month) => `${year}-${month}-01T00:00:00.00Z`;
    const selectedYear = getValidYear(values.year);

    useEffect(() => {
        const year = getValidYear(values.year);
        const month = getValidMonth(values.month, year);

        if (values.year !== year) {
            setFilter({ name: "year", value: year });
        }
        if (values.month !== month) {
            setFilter({ name: "month", value: month });
        }
        setFilter({ name: "reportPeriod", value: getReportPeriod(year, month) });
    }, [values.month, values.year]);

    const getOptionsByName = (name) => {
        switch (name) {
            case "month": {
                return currentYear === minYear
                    ? monthsOptions.slice(parseInt(minMonth, 10) - 1, parseInt(currentMonth, 10))
                    : selectedYear === minYear
                      ? monthsOptions.slice(parseInt(minMonth, 10) - 1)
                      : selectedYear === currentYear
                        ? monthsOptions.slice(0, parseInt(currentMonth, 10))
                        : monthsOptions;
            }
            case "year": {
                const yearOptions = [];
                let i = minYear;
                while (i <= currentYear) {
                    yearOptions.push({ label: i.toString(), value: i });
                    i++;
                }
                return yearOptions;
            }
        }
    };

    const onChange = ({ name, value }) => {
        if (value === null || value === undefined) {
            return;
        }
        if (name === "year") {
            const year = getValidYear(value);
            const month = getValidMonth(values.month, year);
            if (values.month !== month) {
                setFilter({ name: "month", value: month });
            }
            setFilter({ name, value: year });
            return;
        }
        setFilter({ name, value: getValidMonth(value, selectedYear) });
    };

    const getConfigByPropName = (name) => ({
        inputProps: { name },
        options: getOptionsByName(name),
        value: name === "year" ? selectedYear : getValidMonth(values.month, selectedYear),
        onChange,
        unClearable: true,
        styles: {
            container: (styles) => ({ ...styles, minWidth: "150px" }),
        },
    });

    return (
        <>
            <div className="mb-md-0 report__filters--mr">
                <Select {...getConfigByPropName("month")} />
            </div>
            <div className="mb-md-0 report__filters--mr">
                <Select {...getConfigByPropName("year")} />
            </div>
        </>
    );
}
